import script from "./OrgOrderProjectDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrderProjectDetail.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrderProjectDetail.vue?vue&type=style&index=0&id=7e6e9c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6e9c3e"]])

export default __exports__